


















































import {Component, Inject, Prop, Watch, Mixins} from 'vue-property-decorator';
import {HitDetectorWidget} from '@v/dashboard/interfaces';
import {requestHitDetectorData} from '@api/widgetApi';
import {DateTime} from 'luxon';
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import More from 'highcharts/highcharts-more';
import WidgetBindDataSource from '@/components/widgets/base/WidgetBindDataSource.vue';
import Loading from '@c/controls/Loading.vue';
import HitDetectorWidgetBindForm from '@c/widgets/base/bindForms/OrHitDetectorWidgetBindForm.vue';
import {HitDetectorWidgetIntervalType} from './base/bindForms/enums';
import WidgetDataTimerMixin from '@/mixins/WidgetDataTimerMixin';

More(Highcharts);

@Component({
  components: {
    highcharts: Chart,
    WidgetBindDataSource,
    Loading,
    HitDetectorWidgetBindForm,
  },
})
export default class HitDetectorWidgetComponent extends Mixins(WidgetDataTimerMixin) {
  @Inject()
  widget!: HitDetectorWidget;

  hitDetectorData: any[] = [];

  colorScheme: {same: string; different: string} = {
    same: '#F34D2B',
    different: '#9A13B0',
  };

  // Цвет заголовка
  colorCaption = '#e5e5e5';

  // Период обновления данных (секунд)
  daysTimeout = 14400;
  hoursTimeout = 600;

  getTimeout() {
    return this.widget.intervalType == HitDetectorWidgetIntervalType.Days
      ? this.daysTimeout
      : this.hoursTimeout;
  }

  //показатели загрузки данных и наличия ошибок получения данных с сервера
  loading = true;
  error = false;

  startDate!: number;
  endDate!: number;

  intervalType!: HitDetectorWidgetIntervalType;

  date!: number;

  //Узлы для отображения на диаграмме
  nodes: {num: number; id: string; name: string; shortName: string}[] = [];

  //справочник высоты виджета в зависимости от количества подузлов
  heightCardDictionary = [
    {min: 1, max: 2, heightCard: 4, heightChart: 80},
    {min: 3, max: 5, heightCard: 6, heightChart: 140},
    {min: 6, max: 8, heightCard: 8, heightChart: 200},
    {min: 9, max: 11, heightCard: 10, heightChart: 260},
    {min: 12, max: 100, heightCard: 12, heightChart: 320},
  ];

  //Идентификатор узла (т. к. с использованием widget.nodeId темплейт не перерисовывается)
  nodeId: string | null = null;
  nodeName: string | null = null;

  // TODO когда в БД появятся краткие наименования заменить
  get nodeShortName() {
    return this.nodeName;
  }

  //Объект графика
  getChart() {
    return (this.$refs.chart as any)?.chart;
  }

  @Prop({required: false})
  colNum!: number;

  @Watch('colNum')
  onAmountColChanged() {
    this.getChart()?.reflow();
  }

  heightChart = 100;

  // Действия при выборе узла
  onNodeSelect(data: {nodeId: string; nodeName: string}) {
    const intervalType = (this.$refs.bindForm as any).intervalType as HitDetectorWidgetIntervalType;
    const date = (this.$refs.bindForm as any).date as number;
    this.date = date;
    this.intervalType = intervalType;

    this.widget.intervalType = intervalType;
    this.widget.date = date;
    this.widget.nodeId = data.nodeId;
    this.widget.nodeName = data.nodeName;
    this.nodeId = data.nodeId;
    this.nodeName = data.nodeName;
    this.attachNode(this.widget.nodeId, this.widget.intervalType, this.widget.date);
  }

  created() {
    this.nodeId = this.widget.nodeId;
    this.nodeName = this.widget.nodeName;
    this.intervalType = this.widget.intervalType;
    this.date = this.widget.date;
    if (!this.widget.date) this.date = Date.now();

    this.attachNode(this.widget.nodeId, this.widget.intervalType, this.widget.date);
  }

  // Привязка узла
  async attachNode(
    nodeId: string | null,
    intervalType: HitDetectorWidgetIntervalType,
    date: number,
  ) {
    if (!nodeId) return;
    this.loading = true;
    this.getDataTimeout = this.getTimeout();
    this.clearRefresh();
    this.refresh(async () => {
      try {
        await this.getData(nodeId, date);
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    });
  }

  //меняем высоту карточки и заново размещаем карточки на layout
  //то что в справочнике можно получить Math.ceil(this.nodes.length / 3) + 1;
  setHeight() {
    if (!this.nodes.length) return;
    const d = this.heightCardDictionary.find((d: any) => {
      const l = this.nodes.length;
      return d.min <= l && l <= d.max;
    });
    if (d) {
      if (this.widget.h !== d.heightCard) {
        this.widget.h = d.heightCard;
        this.$emit('updateGrid');
      }
      //меняем высоту графика
      this.heightChart = d.heightChart;
    }
  }

  mounted() {
    //хак для обновления диаграммы, после того как станут известны размеры виджета
    this.$nextTick(() => {
      this.getChart()?.reflow();
    });
  }

  xFormatter(e: any): any {
    return e.isLast
      ? 'now'
      : (((e.axis.max - e.pos) * (e.axis.tickAmount - 1) * 2) / (e.axis.max - e.axis.min)).toFixed(
          0,
        );
  }

  yFormatter(e: any): any {
    const filteredNodes = this.nodes.filter(x => x.num === e.value);
    if (filteredNodes.length) return filteredNodes[0].shortName;
    return '';
  }

  async getData(nodeId: string, date: number) {
    this.error = false;

    this.startDate = Math.floor(
      DateTime.fromMillis(date)
        .minus({
          [this.widget.intervalType as string]: this.widget.period,
        })
        .valueOf(),
    );
    this.endDate = date;

    try {
      const {nodes, chartData} = await requestHitDetectorData(nodeId, this.startDate, this.endDate);
      this.hitDetectorData = chartData;
      this.nodes = nodes;
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
      this.setHeight();
    }
  }

  getProcessedData() {
    //для каждого момента времени находим количество ударов
    const lookup = this.hitDetectorData.reduce((a: any, e: any) => {
      a[e.x] = ++a[e.x] || 0;
      return a;
    }, {});

    //удары в один и тот же момент времени
    const same = this.hitDetectorData.filter((e: any) => lookup[e.x]);

    //удары в разные моменты времени
    const different = this.hitDetectorData.filter((e: any) => !lookup[e.x]);

    return {same, different};
  }

  get chartOptions() {
    const {same, different} = this.getProcessedData();

    const series: any[] = [];

    series.push({
      type: 'bubble',
      color: this.colorScheme.same,
      data: same,
    });

    series.push({
      type: 'bubble',
      color: this.colorScheme.different,
      data: different,
    });

    if (same.length) {
      series.push({
        type: 'scatter',
        color: this.colorScheme.same,
        marker: {
          symbol: 'triangle',
          fillOpacity: 0.5,
          radius: 6,
        },
        data: same.map(e => {
          return {x: e.x, y: 0};
        }),
      });
    }

    return {
      credits: {
        enabled: false,
      },
      chart: {
        height: this.heightChart,
        marginRight: 15,
        spacingTop: 0,
        animation: false,
      },
      xAxis: {
        min: this.startDate,
        max: this.endDate,
        opposite: true,
        gridLineWidth: 2,
        gridLineColor: '#c6c6c6',
        gridLineDashStyle: 'dot',
        tickAmount: this.widget.period / 2 + 1,
        endOnTick: false,
        labels: {
          formatter: this.xFormatter,
          style: {
            textOverflow: 'none',
          },
        },
      },
      yAxis: {
        gridLineWidth: 2,
        gridLineColor: '#a6a6a6',
        title: {
          enabled: false,
        },
        max: this.nodes.length + 1,
        min: 0,
        endOnTick: false,
        startOnTick: false,
        tickPositioner: () => {
          return [...Array(this.nodes.length + 1).keys()].slice(1);
        },
        labels: {
          formatter: this.yFormatter,
        },
      },
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          enableMouseTracking: false,
        },
        bubble: {
          minSize: 5,
          maxSize: 15,
        },
      },
      tooltip: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      title: {
        text: '',
      },
      series,
    };
  }
}
